import React, { useState } from 'react';
import { Paper, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

import { ReactComponent as Logo } from '../assets/logo_aut.svg';
import { APP_VERSION } from '../version';

export default function Login() {
  const { login } = useAuth();
  const [adm_login, setLogin] = useState('');
  const [pasw_senha, setSenha] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(adm_login, pasw_senha);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Falha no login';
      setError(msg);
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh', p: 2 }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 420 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <Logo style={{ height: 90, width: 'auto', display: 'block', color: '#fff' }} />
          <Typography
            variant="caption"
            sx={{
              mt: 1,
              px: 1.2,
              py: 0.2,
              borderRadius: 1,
              bgcolor: 'action.hover',
              color: 'text.secondary',
              fontWeight: 700,
              fontSize: '0.75rem',
              letterSpacing: 0.5,
            }}
          >
            Versão {APP_VERSION}
          </Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={onSubmit} noValidate>
          <TextField label="Usuário" value={adm_login} onChange={e=>setLogin(e.target.value)} fullWidth margin="normal" required />
          <TextField label="Senha" type="password" value={pasw_senha} onChange={e=>setSenha(e.target.value)} fullWidth margin="normal" required />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
